import { memo } from "react"

interface BracketCoverProps {
  imageUrl?: string | undefined
  heldOutcomes?: string[] | undefined
  isAnyCardExpanded?: boolean | undefined
  isExpanded?: boolean | undefined
  className?: string | undefined
}

export const BracketCover = memo(function BracketCover({
  imageUrl,
  heldOutcomes = [],
  isAnyCardExpanded = false,
  isExpanded = false,
  className = "",
}: BracketCoverProps) {
  if (!imageUrl || imageUrl.trim() === "") {
    return null
  }

  return (
    <div
      className={`absolute left-[.45rem] top-[.48rem] h-[3.2rem] w-[3.2rem] z-10 pointer-events-none transition-all duration-100 origin-center ${isAnyCardExpanded && !isExpanded ? "opacity-85 group-hover:opacity-100" : ""} ${className}`}
      style={{
        ...(heldOutcomes.length > 0
          ? {
              clipPath:
                'path("M 0 0 L 51 0 L 51 18 L 47 18 Q 43 18 43 23 L 43 28 Q 43 33 47 33 L 51 33 L 51 51 L 0 51 Z")',
            }
          : {}),
      }}
    >
      <img src={imageUrl} alt="" className="h-full w-full object-cover rounded-[.65rem]" loading="lazy" />
      {/* Scanlines overlay */}
      <div className="absolute inset-0 rounded-[.65rem] pointer-events-none scanlines opacity-40 mix-blend-overlay" />
    </div>
  )
})
